import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'USUARIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('usuarioForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/usuario?usuario=true`);
    return {
        type: 'USUARIO_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/usuario`, {
				...registro,
				administrador: true
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				if (registro.acesso_cliente) {
					if (registro.duplicado) {					
						dispatch(salvarPermissao({ 
							...registro,
							id: resp.data.id
						}));
					} else {
						dispatch(setModoTela('lista'));
					}
				} else {
					dispatch(setModoTela('lista'));
				}
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/usuario`, {
				...registro
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(salvarPermissao(registro));
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function alterarSenha(registro) {
    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/usuario/alterarsenha`, {
			...registro
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function salvarPermissao(registro) {
    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/usuario/permissao`, {
			...registro
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaNegociador() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/reports/negociadores`)
		.then(resp => {
			dispatch({
		        type: 'USUARIO_NEGOCIADOR_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaOperacoes() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/operacao/listarSelect`)
		.then(resp => {
			dispatch({
		        type: 'USUARIO_OPERACAO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaFronteira() {
	return (dispatch, getState) => {
	
    	axios.get(`${consts.API_URL}/reports/fronteiras`)
		.then(resp => {
			dispatch({
		        type: 'USUARIO_FRONTEIRA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
		});
	}
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/usuario?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaPerfil() {
    const request = axios.get(`${consts.API_URL}/usuarioPerfil/listarSelect`);
    return {
        type: 'USUARIO_PERFIL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaPerfilAcesso() {
    const request = axios.get(`${consts.API_URL}/perfilAcesso/listarSelect`);
    return {
        type: 'USUARIO_PERFIL_ACESSO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMenu() {
    const request = axios.get(`${consts.API_URL}/usuarioMenu/listarMenuSelect`);
    return {
        type: 'USUARIO_MENU_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUsuarioMenu(id_usuario) {
    const request = axios.get(`${consts.API_URL}/usuarioMenu?id_usuario=${id_usuario}`);
    return {
        type: 'USUARIO_MENU_LISTADO',
        payload: request
    };
}

export function salvarMenu(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/usuarioMenu`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				dispatch(getListaUsuarioMenu(registro.id_usuario));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/usuarioMenu`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				dispatch(getListaUsuarioMenu(registro.id_usuario));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}